import React from 'react'
import Card from './Card/Card'
import './Part2.css'


function Part2() {
    return (
        <div className="Part2-bg-main" id="Part2">

            <div className="spaceholder-part2-top"></div>

            <div className="part2-doc-container">

                <div className="part2-doc-container-inside">

                    <div className="part2-doc-container-inside-pic">

                        <img src="files/SVG/Coding _Monochromatic.svg" className="part2-doc-container-inside-pic-img" alt="" />

                    </div>
                    <div className="part2-doc-container-inside-doc">
                        <h3 className="part2-doc-container-inside-doc-h">چرا الان داشتن وبسایت الزامی است ؟</h3>
                        <br/><br className="spaceholdermovagat"/><br className="spaceholdermovagat"/><br className="spaceholdermovagat"/>
                        <p className="part2-doc-container-inside-doc-d">با توجه به پیشرفت علم و تکنولوژی و مهم بودن آن برای مردم امروزه برای پیشرفت کسب و کار حتما باید در دنیای دیجیتال حظور داشت و صد در صد داشتن وبسایت یکی از بهترین موارد است و تیم ما در تلاش است که بهترین وبسایت مناسب شما را طراحی و کدنویسی و بارگزاری کند.</p>
                        {/* <a href="" className="btn btn--blue btn--blue-part2">وبسایت ها</a> */}
                    </div>

                </div>
            
            </div>

            <div className="spaceholder-part2-top"></div> {/*  bottom space */}

            <div className="part2-option-title-container" id="special-options">
            <h1 className="part2-option-title">نمونه آپشن های خاص وبسایت</h1>
            </div>

            <div className="part2-optin-container" >

                <a className="card-container" href="pages/light & dark mode - Copy/index.html" target="_blank" >

                    <div className="card">
    
                        <img src="files/img/Annotation 2021-10-08 134418.png" alt="pic" className="card-pic" />

                        <h4 className="card-title">Light / Dark Mode</h4>

                    </div>

                </a>

                <a href="pages/hero/index.html" className="card-container">

                    <div className="card">
    
                        <img src="files/img/hero.png" alt="pic" className="card-pic" />
                    
                        <h4 className="card-title">hero background</h4>
                
                    </div>

                </a>

                <a href="pages/smooth scrooll/index.html" className="card-container">

                    <div className="card">
    
                        <img src="files/img/smooth.png" alt="pic" className="card-pic" />
                    
                        <h4 className="card-title">smooth scroll</h4>
                
                    </div>

                </a>

                </div>
                
            {/* <div className="part2-optin-container part2-optin-container-notshow">


                <a href="" className="card-container">

                    <div className="card">
    
                        <img src="files/img/head-main.jpg" alt="pic" className="card-pic" />
                    
                        <h4 className="card-title"> image gallery</h4>
                
                    </div>

                </a>

                <a href="" className="card-container">

                    <div className="card">
    
                        <img src="files/img/head-main.jpg" alt="pic" className="card-pic" />
                    
                        <h4 className="card-title">costimized scrollbar</h4>
                
                    </div>

                </a>

                <a href="" className="card-container">

                    <div className="card">
    
                        <img src="files/img/head-main.jpg" alt="pic" className="card-pic" />
                    
                        <h4 className="card-title">multi language</h4>
                
                    </div>

                </a>


            </div> */}


        </div>
    )
}

export default Part2



// WEBPACK FOOTER //
// ./src/components/Part2/Part2.js